
<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import temps from '@utils/templates.js'
import BaseIcon from '@src/components/_base-icon.vue'

var _ = require('lodash');

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, BaseIcon  },
    data() {
        return {
            showTemplate:false,
            template: {},
            templates: temps.templates
        }
    },
    computed:{

    },
    watch : {

    },
    mounted (){

    },
    methods: {
        selectTemplate: function(template){
            if(template.parameters && template.parameters.length > 0){
                this.showTemplate = true;
                this.template = template;
            }else{
                this.goToEditor(template);
            }
        },
        processParameters: function(){
            let markdown = this.template.markdown;
            this.template.parameters.forEach(function(p){
                const regex = new RegExp("{{"+p.replace+'}}', "g");
                markdown = markdown.replace(regex, p.value);
            });
            this.template.markdown = markdown;
            this.goToEditor(this.template)
        },
        goToEditor: function(template){
            this.$store.commit('lineCommand/clearLines');

            this.$store.commit('lineCommand/setMarkdown', template.markdown);

            for(let i = 0; i < template.config.tickets.length; i++){
                const line = template.config.tickets[i];
                this.$store.commit('lineCommand/addTicket', line);
            }

            for(let i = 0; i < template.config.documentation.length; i++){
                const line = template.config.documentation[i];
                this.$store.commit('lineCommand/addDoc', line);
            }

            this.$router.push({ path: 'editor' });
        }
    }
}
</script>

<template>
  <Layout>

    <div class="row mt-4">
      <div class="col-10">
        <h4>Create Features</h4>
      </div>
      <div class="col-2 text-right">
        <button class="btn btn-primary">Generate Assets</button>
      </div>
    </div>

      <div class="container">
          <div v-show="!showTemplate">
              <h4>Select Template</h4>
              <div v-for="(t, tIndex) in templates" :key="tIndex" class="card p-3 m-3">
                  <div class="row d-flex" >
                      <div class="col-2 text-center justify-content-center align-self-center">
                          <h2><BaseIcon :name="t.icon"></BaseIcon></h2>
                      </div>
                      <div class="col-8">
                          <div >
                              <h4>{{t.title}}</h4>
                              <div v-html="t.description"></div>
                          </div>
                      </div>
                      <div class="col-2  text-center justify-content-center align-self-center">
                          <button class="btn btn-primary" @click="selectTemplate(t)">Select</button>
                      </div>
                  </div>
              </div>
          </div>
          <div v-show="showTemplate">
            <div class="col">
                <h4>{{template.name}} Parameters</h4>
                <p>This template requires the following parameters to generate content:</p>
            </div>
            <div v-for="(parameter, pIndex) in template.parameters" :key="pIndex" class="card p-3">

                <div class="row">
                    <h5 class="col-12">{{parameter.name}}</h5>
                    <div class="col-6">
                        <input v-model="parameter.value" class="form-control" />
                    </div>
                    <div class="col-6">
                        <p><em>{{parameter.description}}</em></p>
                    </div>
                </div>
            </div>
            <div class="col text-right mt-3">
                <button class="btn btn-primary" v-on:click="processParameters">Generate</button>
            </div>
          </div>
      </div>

  </Layout>
</template>

<style>
  .docs-panel-content{
    background: #FFFFFF;
  }
  .collapsed-col{
    width:30px;
    background-color: #F2F6FB;
    text-align:center;
    margin-right: 15px;
  }
  .epic{
    background: #FFFFFF;
  }
  .columnHeader h5 svg{
    margin-top:-3px;
  }
  .columnHeader h5 span{
    margin-left:8px;
  }

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
      transition: all 0.6s ease-in-out;
  }
  .slide-fade-leave-active {
      transition: all 0.6s ease-in-out;
  }
  .slide-fade-enter, .slide-fade-leave-to
      /* .slide-fade-leave-active below version 2.1.8 */ {
      transform: translateX(10px);
      opacity: 0;
  }


</style>
